import { useDispatch, useSelector } from 'react-redux'
import { setObservacionesPedido } from '../../actions/pedidos'
import { LONG_PEDIDO } from '../../helpers/longitudesPedido'
import i18n from '../../lang/idiomas'

const ObservacionesPedido = ({ pedidoGuardado }) => {
  const dispatch = useDispatch()

  const isLoading = useSelector(state => state.pedidos.isLoading)
  const observaciones = useSelector(state => state.pedidos.pedido.observaciones)

  const onChange = e => {
    if (!isLoading) {
      dispatch(setObservacionesPedido(e.target.value))
    }
  }

  return (
    <form className='form-default observaciones-pedido'>
      <div className='form-group'>
        <label htmlFor='observaciones'>
          {i18n.t('pedido.pobsrped', 'Observaciones del pedido')}
        </label>
        <textarea
          className='form-control'
          rows='4'
          name='observaciones'
          id='observaciones'
          value={observaciones && observaciones !== '' ? observaciones : ''}
          onChange={onChange}
          disabled={pedidoGuardado}
          placeholder={i18n.t('pedido.pobsrph', 'Añade aquí cualquier indicación para tu pedido')}
          maxLength={LONG_PEDIDO.observaciones}
        />
        <small className='form-text text-muted text-right'>
          {(observaciones || '').length}/{LONG_PEDIDO.observaciones}
        </small>
      </div>
    </form>
  )
}

export default ObservacionesPedido
